import { createSignal } from 'solid-js';
import { useTranslation } from '../hooks/useTranslation';

export default function TextWithCopyButton({ text }: { text: string }) {
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = createSignal(false);
    let timer: ReturnType<typeof setTimeout> | null = null;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            if (timer !== null) clearTimeout(timer);
            timer = setTimeout(() => {
                setIsCopied(false);
                timer = null;
            }, 1500);
        } catch (_err) {
            /* clipboard unavailable — silent */
        }
    };

    return (
        <div class="text-copy-container">
            <span class="text-content"><b>{text}</b></span>
            <button
                onClick={copyToClipboard}
                class="copy-button"
                aria-live="polite"
                title={isCopied() ? t("COPIED_SHORT") : t("COPY_TO_CLIPBOARD")}
            >
                <i class={`fa-solid ${isCopied() ? "fa-check" : "fa-copy"}`} aria-hidden="true" />
                <span style={{ "margin-left": "6px" }}>{isCopied() ? t("COPIED_SHORT") : t("COPY")}</span>
            </button>
        </div>
    );
}
